// 随机字符串
//  const randomHash = () => Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2)
function randomHash() {
  return Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2)
}

export default randomHash
export { randomHash }
